export default "__VITE_ASSET__CFy822Sm__"